/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Component, OnInit, ChangeDetectionStrategy, forwardRef, Input } from '@angular/core'
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms'
import { Observable } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { DestroyService } from '@core/services/destroy.service'
import { DataService } from '@shared/services/data.service'
import { Language } from '@shared/models/language.model'

@Component({
  selector: 'lin-language-field',
  templateUrl: './language-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LanguageFieldComponent),
      multi: true,
    },
    DestroyService,
  ],
  standalone: false,
})
export class LanguageFieldComponent implements OnInit, ControlValueAccessor {
  control = new FormControl()
  languages$: Observable<Language[]>

  @Input() required = false

  constructor(
    private readonly dataService: DataService,
    private readonly destroyService: DestroyService,
  ) {}

  ngOnInit(): void {
    this.languages$ = this.dataService.getLanguages()
  }

  writeValue(obj: any): void {
    this.control.setValue(obj)
  }

  registerOnChange(fn: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    this.control.valueChanges.pipe(takeUntil(this.destroyService)).subscribe((value) => fn(value))
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerOnTouched(fn: any): void {}
}
